



















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import ProductSectorsModal from '../modals/ProductSectorsModal.vue';
import showFilesModal from '../components/showFiles.vue';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'product-sectors',
    data: function () {
        return {
            ordersPage_: 1,
        };
    },
    components: {
        ProductSectorsModal,
        showFilesModal,
        Spinner,
    },
    computed: {
        ...mapState('productSectors', ['allProductSectors', 'allProductSectorsLoading']),
        ...mapState('auth', ['currentUser']),
    },
})
export default class ProductSectors extends Vue {
    public allProductSectors!: any;
    public allProductSectorsLoading!: any;
    public sector_search: any = '';
    public ordersPerPage!: any;
    public ordersPage!: any;
    // public ordersTotal!: any;
    private activeOrderLoaded: boolean = false;
    private activeFilters: boolean = false;

    allProductSectorsHeaders = [
        { thClass: 'th', key: 'id', label: 'ID' },
        { thClass: 'th', key: 'name', label: 'Nombre' },
        { thClass: 'th', key: 'edit', label: '' },
        { thClass: 'th', key: 'delete', label: '' },
    ];

    private currentUser!: any;

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    get allProductSectorsCollection() {
        return this.allProductSectors.filter((cat) => {
            return (
                cat.name.includes(this.sector_search) ||
                cat.name.toLowerCase().includes(this.sector_search) ||
                cat.name.toUpperCase().includes(this.sector_search)
            );
        });
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'product-sectors',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    setUrlSearch(search: string) {
        this.$router.push({
            path: 'product-sectors',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    clearFilters() {
        this.$router.push({
            path: 'orders',
            query: {},
        });
    }

    onEditOrder(id: number) {
        this.$store.dispatch('orders/getOne', { id });
        this.activeOrderLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('order-detail-modal');
        }, 400);
    }

    @Watch('$route')
    getAllProductSectors() {
        if (this.$route.query.search) {
            this.$store.dispatch('productSectors/getAll', {
                search: <string>this.$route.query.search,
            });
        } else {
            this.$store.dispatch('productSectors/getAll');
        }
    }

    onOpenProductSectorModal(id: string | null = null) {
        this.$store.dispatch('productSectors/getOne', id);
        setTimeout(() => {
            this.$bvModal.show('product-sectors-modal');
        }, 400);
    }

    onDeleteProductSectorModal(id: string) {
        this.$store.dispatch('productSectors/deleteOne', { id, vm: this });
        setTimeout(() => {
            this.$store.dispatch('productSectors/getAll');
        });
    }

    mounted() {
        this.getAllProductSectors();
        this.ordersPage = 1;
    }
}
